import { Component, Inject, Input, OnChanges, OnDestroy, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CartService } from '../../services/cart.service';
import { WishlistService } from '../../services/wishlist.service';
import { CompareService } from '../../services/compare.service';
import { RootService } from '../../services/root.service';
import { ArticoloFull } from '../../interfaces/custom/articolo';
import { CartArticoloOption, OptionVariant } from '../../interfaces/custom/cart_articolo_option';
import { PriceArticoloService } from '../../services/custom/price-articolo.service';
import { aspectRatioImgGoogle, scaleImg } from '../../helpers/scale_img';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { StoreService } from '../../services/store.service';
import { AccountService } from '../../services/custom/account.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { AsyncSubject, Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProductCustomizationComponent } from '../product-customization/product-customization.component';
import { ShopService } from '../../api/shop.service';
import { AnagraficaConf, Confezione } from '../../interfaces/custom/confezioni';

export type ProductLayout = 'standard' | 'sidebar' | 'columnar' | 'quickview';

const STR_OPT_LIST = 'option_list';
const STR_OPT_CODE = 'option_code';

@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnChanges, OnDestroy {
    @Input() layout: ProductLayout;

    @Input() articolo: ArticoloFull;
    get giacenza() {
        if (!this.articolo)
            return 0;

        if (this.optionForm && !this.isListinoExist())
            return 0;

        if (this.articolo.tipo_articolo == 5 || this.articolo.tipo_articolo == 6) {
            if (!this.articolo.flg_esplosione)
                return true;
        }

        if (this.articolo.acquisti_giacenza_negativa)
            return true;

        if (!this.optionForm) {
            let qta = this.cart.getQuantityOfItemInCart(this.articolo);
            let remain_qta = this.articolo.giacenze.giacenza.giacenza - qta;
            return remain_qta;
        }

        let combinations = this.getPossibleCombinationOfActiveOptions();
        let quantity = this.calcGiacenzaOption(combinations);

        if (this.quantity.value > quantity) {
            if (this.store.price == 'b2c')
                this.quantity.setValue(quantity >= 1 ? quantity : 1);
        }
        return quantity;
    }

    quantity: FormControl = new FormControl(1);
    optionForm;


    addingToCart = false;
    addingToWishlist = false;
    addingToCompare = false;

    ingredientiModalRef: BsModalRef;

    private destroy$: Subject<void> = new Subject<void>();

    private conf$ = new AsyncSubject<AnagraficaConf[]>();

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private cart: CartService,
        private wishlist: WishlistService,
        private compare: CompareService,
        public root: RootService,
        private title: Title,
        public store: StoreService,
        private meta: Meta,
        public price: PriceArticoloService,
        private modalService: BsModalService,
        public accountService: AccountService,
        private shop: ShopService,
        private sanitizer : DomSanitizer,
    ) {
        if (this.store.price == 'b2b') {
            this.shop.getConfezioniDesc().subscribe(r => {
                this.conf$.next(r);
                this.conf$.complete();
            });
        }

        this.cart.items$.pipe(takeUntil(this.destroy$)).subscribe(items => {
            if (!this.articolo)
                return;
            this.quantity.setValue(this.min);
        });
    }

    removeTags() {
        this.meta.removeTag('name="description"');
        this.meta.removeTag('name="og:type"');
        this.meta.removeTag('name="og:title"');
        this.meta.removeTag('name="og:image"');
        this.meta.removeTag('name="og:image:secure_url"');
        this.meta.removeTag('name="og:price:amount"');
        this.meta.removeTag('name="og:price:currency"');
        this.meta.removeTag('name="og:description"');
        this.meta.removeTag('name="og:url"');
    }

    ngOnDestroy(): void {
        this.title.setTitle(this.store.name);
        this.removeTags();

        this.destroy$.next();
        this.destroy$.complete();
    }

    images;

    icone_allergeni;

    conf_active : Confezione;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['articolo']) {

            this.conf_active = undefined;

            if (this.store.price == 'b2b') {
                this.conf$.subscribe(r => {
                    for (let conf of this.articolo.confezioni_articolo) {
                        let an_conf = r.find(obj => obj.codice_confezione == conf.codice_confezione);
                        conf.confezione_desc = an_conf.descrizione;
                    }
                });

                if (this.articolo.confezioni_articolo?.length) {
                    let conf = this.articolo.confezioni_articolo.find(obj => obj.flag_preferenziale);
                    if (!conf) {
                        conf = this.articolo.confezioni_articolo[0];
                    }
                    this.conf_active = conf;
                }
            }
            
            if (false)
                this.articolo.attributi = [
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    },
                    {
                        "codice_articolo": "093",
                        "progressivo": 1,
                        "descrizione": "8",
                        "selected": false,
                        "prezzo": 7.000000,
                        "tipo_battuta": 0,
                        "articolo_collegato": "093"
                    }
                ]

            let icone_allergeni = new Set();

            for (let ingrediente of this.articolo.ingredienti) {
                try {
                    for (let allergene of ingrediente.dati) {
                        if (allergene.icona)
                            icone_allergeni.add(allergene.icona);
                    }
                } catch (err) { }
            }

            this.icone_allergeni = Array.from(icone_allergeni);

            this.title.setTitle(this.articolo.descart + ' - ' + this.store.name);

            let description = 'Acquista "' + this.articolo.descart + '"';
            if (this.articolo.descrizione_estesa)
                description += '. ' + this.articolo.descrizione_estesa;

            this.removeTags();
            this.meta.addTags([
                {
                    'name': 'description',
                    'content': description
                },
                {
                    'name': 'og:type',
                    'content': 'product'
                },
                {
                    'name': 'og:title',
                    'content': this.articolo.descart
                },
                {
                    'name': 'og:image',
                    'content': this.articolo.cdn_url
                },
                {
                    'name': 'og:image:secure_url',
                    'content': this.articolo.cdn_url
                },
                {
                    'name': 'og:price:amount',
                    'content': String(this.price.prezzoArticolo(this.articolo))
                },
                {
                    'name': 'og:price:currency',
                    'content': 'EUR'
                },
                {
                    'name': 'og:description',
                    'content': this.articolo.descart
                },
                {
                    'name': 'og:url',
                    'content': document.URL
                }
            ]);

            this.quantity.setValue(this.min);

            this.optionForm = null;
            let group = {};
            for (let i = 1; i <= 4; i++) {
                if (this.articolo['optionlist' + i]) {
                    let options = this.option_disponibili(i);
                    let defaultValue = options.length ? options[0].progressivo : 0;
                    group[i] = new FormControl(defaultValue);
                }
            }

            if (Object.keys(group).length) {
                this.optionForm = new FormGroup(group);
                this.optionForm.valueChanges.subscribe(newValue => {
                    this.updateImages();
                    if (this.store.price == 'b2b') {
                        this.quantity.setValue(this.min);
                    }
                });
            }

            this.img_for_google = aspectRatioImgGoogle(this.articolo.cdn_url).map(url => this.sanitizer.bypassSecurityTrustResourceUrl(url));
            this.articolo.cdn_url = scaleImg(this.articolo.cdn_url, 500, 500);
            this.articolo.image_gallery.forEach(imageDef => imageDef.url = scaleImg(imageDef.url, 500, 500));

            this.updateImages();
        }
    }

    updateImages() {
        let filterObj = {};
        for (let i = 1; i <= 4; i++) {
            filterObj["option_code" + i] = 0;
        }

        let filter_images = (filterObj) => {
            return this.articolo.image_gallery.filter(imageDef => {
                for (let key of Object.keys(filterObj))
                    if (imageDef[key] != filterObj[key])
                        return false;
                return true;
            }).map(imageDef => imageDef.url);
        };

        if (!this.optionForm) {
            this.images = [this.articolo.cdn_url].concat(filter_images(filterObj));
        }
        else {
            let optionFilterObj = { ...filterObj };
            for (let key of Object.keys(this.optionForm.value)) {
                optionFilterObj["option_code" + key] = this.optionForm.value[key];
            }
            this.images = filter_images(optionFilterObj);
            if (!this.images.length)
                this.images = [this.articolo.cdn_url].concat(filter_images(filterObj));
        }
    }

    get min() {
        if (this.store.price == 'b2c')
            return 1;
        else if (this.conf_active)
            return this.conf_active.pezzi_confezione;
        else {
            if (this.cart.getCartItem(this.articolo, this.makeCartArticoloOption())) {
                return this.articolo.livello_riordino;
            }
            return this.articolo.minimo_acquisto;
        }
    }

    get step() {
        if (this.store.price == 'b2c')
            return 1;
        else if (this.conf_active)
            return this.conf_active.pezzi_confezione;
        else
            return this.articolo.livello_riordino;
    }

    makeCartArticoloOption() {
        let options: CartArticoloOption;
        if (this.optionForm) {
            options = {};
            for (let control of Object.keys(this.optionForm.controls)) {
                let progressivo = this.optionForm.controls[control].value;
                let variant = this.option_disponibili(control).find(v => v.progressivo == progressivo);

                options[control] = {
                    list: this.optionlist(control),
                    option: variant
                }
            }
        }
        return options;
    }

    addToCart(): void {
        if (!this.addingToCart && this.articolo && this.quantity.value > 0) {

            this.addingToCart = true;

            let options: CartArticoloOption = this.makeCartArticoloOption();

            let articoloCopy = { ...this.articolo };
            articoloCopy.cdn_url = this.images[0];

            if (this.conf_active) {
                articoloCopy.conf_active = this.conf_active;
            }

            if (this.articolo.tipo_articolo == 5 || this.articolo.tipo_articolo == 6) {
                this.shop.getArticoliComposizione(this.articolo.codart)
                .pipe(
                    finalize(() => {
                        this.addingToCart = false;
                    })
                )
                .subscribe(
                    r => {
                        let modalRef = this.modalService.show(ProductCustomizationComponent, {
                            class: 'modal-dialog-centered modal-xl customized-modal-dialog',
                            initialState: {
                                articolo: JSON.parse(JSON.stringify(this.articolo)),
                                qta: this.quantity.value,
                                articoli: r,
                                options: this.makeCartArticoloOption()
                            }
                        });
                        modalRef.content.onClose = () => {
                            this.quantity.setValue(this.min);
                        };
                    },
                    err => {
                        alert(JSON.stringify(err));
                    }
                )

                return;
            }
            else if (this.articolo.attributi && this.articolo.attributi.length) {
                let modalRef = this.modalService.show(ProductCustomizationComponent, {
                    class: 'modal-dialog-centered modal-xl customized-modal-dialog',
                    initialState: {
                        articolo: JSON.parse(JSON.stringify(this.articolo)),
                        qta: this.quantity.value,
                    }
                });
                this.addingToCart = false;
                modalRef.content.onClose = () => {
                    this.quantity.setValue(this.min);
                }
                return;
            }

            this.cart.add(articoloCopy, this.quantity.value, options).subscribe({
                complete: () => {
                    this.addingToCart = false;
                    this.quantity.setValue(this.min);
                }
            });
        }
    }

    addToWishlist(): void {
        if (!this.addingToWishlist && this.articolo) {
            this.addingToWishlist = true;

            this.wishlist.add(this.articolo).subscribe({ complete: () => this.addingToWishlist = false });
        }
    }

    addToCompare(): void {
        // if (!this.addingToCompare && this.product) {
        //     this.addingToCompare = true;

        //     this.compare.add(this.product).subscribe({complete: () => this.addingToCompare = false});
        // }
    }

    canAddToCart() {
        if (this.optionForm) {
            for (let control of Object.keys(this.optionForm.controls))
                if (!this.optionForm.controls[control].value)
                    return false;
        }

        if (this.articolo.non_acquistabile) {
            return false;
        }

        return this.isAvailable();
    }

    isAvailable() {
        let giacenza = this.giacenza;
        if (typeof giacenza == 'boolean')
            return giacenza;
        else if (typeof giacenza == 'number') {
            return giacenza - this.quantity.value >= 0;
        }
        return giacenza >= 1;
    }

    optionlist = (num) => this.articolo['optionlist' + num];
    option_disponibili = (num) => this.articolo['option_disponibili_' + num];

    isOptionAvailable(list, progressivo) {
        if (!this.optionForm)
            return false;

        if (!this.isListinoExist({list, progressivo}))
            return false;

        if (this.articolo.acquisti_giacenza_negativa)
            return true;

        let listObj = this.optionlist(list);

        let listToSkip;
        if (listObj.indmagazzino) {
            let comb = {};
            comb[STR_OPT_LIST + list] = listObj.option_list;
            comb[STR_OPT_CODE + list] = progressivo;

            listToSkip = { list, comb };
        }

        let combinations = this.getPossibleCombinationOfActiveOptions(listToSkip);
        return this.calcGiacenzaOption(combinations);
    }

    calcGiacenzaOption(combinations: any[]): number {
        let giacenza_opt = this.articolo.giacenze.giacenza_opt;
        let cart_quantity = this.cart.getQuantityOfItemWithOptions(this.articolo);

        let isEqual = (a, b) => {
            for (let i = 1; i <= 4; i++) {
                if (a[STR_OPT_LIST + i] != b[STR_OPT_LIST + i] ||
                    a[STR_OPT_CODE + i] != b[STR_OPT_CODE + i])
                    return false;
            }
            return true;
        }

        let total = 0;
        for (let comb of combinations) {
            let giacenzaObj = giacenza_opt.find(obj => isEqual(obj, comb));
            let cartQuantityObj = cart_quantity.find(obj => isEqual(obj, comb));

            let diff = (giacenzaObj ? giacenzaObj.giacenza : 0) - (cartQuantityObj ? cartQuantityObj.giacenza : 0);
            if (diff > 0)
                total += diff;
        }
        return total;
    }

    getPossibleCombinationOfActiveOptions(skipList?: {
        list: number,
        comb: object
    }, ignoreIndMagazzino?): any[] {

        let combinations: any[] = [{}];
        if (skipList)
            combinations = [skipList.comb];

        for (let i = 1; i <= 4; i++) {
            if (skipList && skipList.list == i)
                continue;
            if (!this.optionlist(i) || (!ignoreIndMagazzino && !this.optionlist(i).indmagazzino)) {
                combinations = combinations.map(comb => {
                    comb[STR_OPT_LIST + i] = 0;
                    comb[STR_OPT_CODE + i] = 0;
                    return comb;
                });
            }
            else if (this.optionForm.controls[i].value) {
                combinations = combinations.map(comb => {
                    comb[STR_OPT_LIST + i] = this.optionlist(i).option_list;
                    comb[STR_OPT_CODE + i] = this.optionForm.controls[i].value;
                    return comb;
                });
            }
            else {
                function mapToMultiple(arr: any[], callback: (obj) => any[]) {
                    let newArr = [];
                    arr.forEach(obj => {
                        newArr = [...newArr, ...callback(obj)];
                    });
                    return newArr;
                }

                combinations = mapToMultiple(combinations, oldComb => {
                    let combs = [];
                    this.option_disponibili(i).forEach(option => {
                        let newComb = { ...oldComb };
                        newComb[STR_OPT_LIST + i] = this.optionlist(i).option_list;
                        newComb[STR_OPT_CODE + i] = option.progressivo;
                        combs.push(newComb);
                    })
                    return combs;
                });
            }
        }

        return combinations;
    }

    showModalIngredienti(template) {
        this.ingredientiModalRef = this.modalService.show(template, { class: 'modal-dialog-centered modal-lg' });
    }

    setConfezione(conf) {
        this.conf_active = conf;
        this.quantity.setValue(conf.pezzi_confezione);
    }

    currentUrl() {
        return this.sanitizer.bypassSecurityTrustResourceUrl(window.location.href);
    }

    img_for_google;

    get countOfItemInCart() {
        return this.cart.getQuantityOfItemInCart(this.articolo);
    }

    isListinoExist(skip?) {
        let listToSkip;
        if (skip) {
            let list = skip.list;
            let progressivo = skip.progressivo;
            let listObj = this.optionlist(list);

            let comb = {};
            comb[STR_OPT_LIST + list] = listObj.option_list;
            comb[STR_OPT_CODE + list] = progressivo;
            listToSkip = { list, comb };
        }
        let combinations = this.getPossibleCombinationOfActiveOptions(listToSkip, true);

        combinations = combinations.map(comb => {
            let obj = {};
            for (let i = 1; i < 4; i++)
                obj[i] = comb['option_code' + i];
            return obj;
        });

        return combinations.some(comb => this.price.prezzoArticolo(this.articolo, comb) != -1);
    }
}
